import { translate } from "../../util/translate"

export const transferHeaders = [
  {
    text: translate['transfer.label.name'],
    value: 'host',
    width: '200',
  },
  {
    text: translate['transfer.label.receiver'],
    value: 'receiver_type',
    width: '120',
  },
  {
    text: translate['transfer.label.createdAt'],
    value: 'created_at',
    width: '150',
  },
  {
    text: translate['transfer.label.status'],
    value: 'status',
    width: '150',
  },
  {
    text: translate['transfer.label.asaasTransferId'],
    value: 'asaas_transfer_id',
    width: '150',
  },
  {
    text: translate['transfer.label.appointment'],
    value: 'appointment',
    width: '50',
  },
  {
    text: translate['transfer.label.total'],
    value: 'total',
    width: '150',
    align: 'right',
  },
  { value: 'actions', align: 'end', width: 50 },
]

export const transferHistoryHeaders = [
  {
    text: translate['transfer.details.history.createdAt'],
    value: 'created_at',
    width: '130',
  },
  {
    text: translate['transfer.details.history.status'],
    value: 'status',
    width: '100',
  },
  {
    text: translate['transfer.details.history.description'],
    value: 'description',
    width: '400',
  },
]

export const transferPaymentHeaders = [
  {
    text: '',
    value: 'data-table-expand',
    width: 50,
  },
  {
    text:  translate['transfer.details.payments.type'],
    value: 'type',
  },
  {
    text: translate['transfer.details.payments.details'],
    value: 'appointmentCode',
  },
  {
    text: translate['transfer.details.payments.appointmentDate'],
    value: 'appointmentDate',
  },
  {
    text: translate['transfer.details.payments.createdAt'],
    value: 'created_at',
  },
  {
    text: translate['transfer.details.payments.total'],
    value: 'total',
    width: 150,
    align: 'end',
  },
]

export const transferInvoicesHeaders = [
  {
    text: translate['hausefulInvoices.headers.host'],
    value: 'host',
    width: 250,
  },
  {
    text: translate['hausefulInvoices.headers.customer'],
    value: 'real_estate',
    width: 250,
  },
  {
    text: translate['hausefulInvoices.headers.sender'],
    value: 'sender',
    width: 100,
  },
  {
    text: translate['hausefulInvoices.headers.receiver'],
    value: 'receiver',
    width: 100,
  },
  {
    text: translate['hausefulInvoices.headers.comment'],
    value: 'comment',
    width: 250,
  },
  {
    text: translate['hausefulInvoices.headers.status'],
    value: 'status',
    width: 100,
  },
  {
    text: translate['hausefulInvoices.total'],
    value: 'total',
    align: 'end',
    width: 150,
  },
  {
    text: '',
    value: 'actions',
    align: 'end',
    width: 50,
  },
]
